import { inject, Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BackendService {
  private storageService: StorageService = inject(StorageService);
  private domain$: ReplaySubject<string> = new ReplaySubject(1);
  public API_URL_SUFFIX_PART = environment.production;

  public getDomain(): Observable<string> {
    return this.domain$;
  }

  public setDomain(domain: string): void {
    this.domain$.next(domain);
  }

  public getApiUrl(): string {
    const rawLanguage = sessionStorage.getItem('app_language');
    let language = 'ru';

    if (rawLanguage) {
      try {
        const parsedLanguage = JSON.parse(rawLanguage);
        if (typeof parsedLanguage === 'string' && parsedLanguage.trim()) {
          language = parsedLanguage;
        }
      } catch {
        language = rawLanguage;
      }
    }

    return `${this.API_URL_SUFFIX_PART}${language}`;
  }
}
